import FastClick from 'fastclick'

let navbarHeight = undefined

const isMobileNav = () => $('.check-for-mobile').css('float') === 'none'
const isCollapsible = () => $('main').height() > $(window).height()
const isCollapsed = () => isMobileNav() || $('body').hasClass('navbar-collapsed')

function updateCollapse() {
  if (!navbarHeight || !isCollapsible()) { return }

  const body = $('body')
  const collapsed = body.hasClass('navbar-collapsed')
  const toggle = (collapsed && (window.pageYOffset < navbarHeight)) ||
    (!collapsed && (window.pageYOffset >= navbarHeight))

  if (toggle) { body.toggleClass('navbar-collapsed') }
  sizeNavbar()
}

function sizeNavbar() {
  if ($('.cookie-consent-dropdown').length == 0) { return }

  $('.navbar-fixed-top').css('top', 0)
  $('.navbar-fixed-top .navbar-default').css('top',
    `${$('.cookie-fixed-top .nav-cookies').height()}px`)
}

$(document)
  .on('turbolinks:load', function() {
    FastClick.attach(document.body)
    if ($('.navbar').is(':visible')) { navbarHeight = $('.navbar').height() }
    sizeNavbar()
  })

  .on('hide.bs.dropdown', '.navbar-nav', function(event) {
    if (isCollapsed()) {
      event.stopPropagation()
      event.preventDefault()
    }
  })

  .on('show.bs.dropdown', '.navbar-nav', function(event) {
    if (isCollapsed()) {
      $(event.target).siblings().toggleClass('child-expanded')
    }
  })

  .on('click', '.navbar-nav .dropdown.open > .dropdown-toggle', function(event) {
    if (isCollapsed()) {
      let parent = $(event.currentTarget).parent()
      parent.removeClass('open').siblings().toggleClass('child-expanded')
      event.stopPropagation()
      event.preventDefault()
    }
  })

  .on('click', '#search-button', () => $('#search').focus())

  .on('scroll click turbolinks:load', function(event) {
    if (!isMobileNav || !$.contains($('.navbar-collapse')[0], event.target)) {
      $('.navbar-collapse').collapse('hide')
      $('.navbar .open:not(.search-dropdown)').removeClass('open')
    }
  })

  .on('scroll', updateCollapse)

  .on('hidden.bs.collapse', '.navbar-collapse', function() {
    $('.navbar .child-expanded').removeClass('child-expanded')
    $('.navbar .open').removeClass('open')
  })

window.addEventListener('resize', sizeNavbar)
